import dayjs from 'dayjs'
import isToday from "dayjs/plugin/isToday"
import isYesterday from "dayjs/plugin/isYesterday"
import { useI18n } from 'vue-i18n'

// Initialize dayjs plugins
dayjs.extend(isToday)
dayjs.extend(isYesterday)

// Helper to remove leading zeros
const removeLeadingZero = (str) => str.replace(/^0/, '')

/**
 * Format date as MM/D
 * @param {Date|string} date - The date to format
 * @returns {string} Formatted date string
 */
export function mmdd(date) {
  return removeLeadingZero(dayjs(date).format('MM/D'))
}

/**
 * Format date as MM/D/YY
 * @param {Date|string} date - The date to format
 * @returns {string} Formatted date string
 */
export function dmyyyy(date) {
  return removeLeadingZero(dayjs(date).format('MM/D/YY'))
}

/**
 * Format date as MM-D-YY
 * @param {Date|string} date - The date to format
 * @returns {string} Formatted date string
 */
export function dmyyyy_dash(date) {
  return removeLeadingZero(dayjs(date).format('MM-D-YY'))
}

/**
 * Format date as MMM D, YYYY
 * @param {Date|string} date - The date to format
 * @returns {string} Formatted date string
 */
export function hhmmyyyy(date) {
  return removeLeadingZero(dayjs(date).format('MMM D, YYYY'))
}

/**
 * Format date as MMM D YYYY h:mm a
 * @param {Date|string} date - The date to format
 * @returns {string} Formatted date string
 */
export function hhmmyyyyt(date) {
  return removeLeadingZero(dayjs(date).format('MMM D YYYY h:mm a'))
}

/**
 * Format time as h:mm a
 * @param {Date|string} date - The date to format
 * @returns {string} Formatted time string
 */
export function hhmma(date) {
  return removeLeadingZero(dayjs(date).format('h:mm a'))
}

/**
 * Format time as h:mm
 * @param {Date|string} date - The date to format
 * @returns {string} Formatted time string
 */
export function hhmm(date) {
  return removeLeadingZero(dayjs(date).format('h:mm'))
}

/**
 * Get number of days between date and now
 * @param {Date|string} date - The date to compare
 * @returns {number} Number of days
 */
export function daysFromNow(date) {
  return Math.abs(dayjs().diff(dayjs(date), 'days'))
}

/**
 * Format date for table display with special handling for today and future dates
 * @param {Date|string} date - The date to format
 * @returns {string} Formatted date string
 */
export function tableDateFormat(date) {
  if (!date) return ''
  
  const { t } = useI18n({})
  const dateObj = dayjs(date)

  if (dateObj.isToday()) {
    return `${t("common.today")} ${dateObj.format(" @ h:mm a")}`
  }
  
  if (date.includes("2025")) {
    return dateObj.format("M-DD-YY @ h:mm a")
  }
  
  return dateObj.format("MM-DD-YYYY @ h:mm a")
}